import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import axios from 'axios';

const geocode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* ({
    latitude,
    longitude,
    apiKey
  }) {
    const location = {};
    const zipCodes = [];
    const cities = [];
    let state = '';
    let country = '';
    const geoCodedResults = yield axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`);

    if (geoCodedResults && geoCodedResults.status === 200) {
      const _geoCodedResults$data = geoCodedResults.data,
            status = _geoCodedResults$data.status,
            results = _geoCodedResults$data.results;

      if (status !== 'OK' || results.length === 0) {
        location.success = false;
        location.message = 'No location results matched the given latitude and longitude';
        return location;
      }

      const postalCodeAddresType = results.find(x => x.types.includes('postal_code'));

      if (postalCodeAddresType && postalCodeAddresType.address_components) {
        const postalCodeAddressComponent = postalCodeAddresType.address_components.find(x => x.types.includes('postal_code'));

        if (postalCodeAddressComponent) {
          zipCodes.push(postalCodeAddressComponent.long_name);
        }
      }

      const cityAddressType = results.find(x => x.types.includes('locality'));

      if (cityAddressType && cityAddressType.address_components) {
        const cityAddressComponent = cityAddressType.address_components.find(x => x.types.includes('locality'));

        if (cityAddressComponent) {
          cities.push(cityAddressComponent.long_name);
        }
      }

      const stateAddressType = results.find(x => x.types.includes('administrative_area_level_1'));

      if (stateAddressType && stateAddressType.address_components) {
        const stateAddressComponent = stateAddressType.address_components.find(x => x.types.includes('administrative_area_level_1'));

        if (stateAddressComponent) {
          state = stateAddressComponent.short_name;
        }
      }

      const countryAddressType = results.find(x => x.types.includes('country'));

      if (countryAddressType && countryAddressType.address_components) {
        const countryAddressComponent = countryAddressType.address_components.find(x => x.types.includes('country'));

        if (countryAddressComponent) {
          country = countryAddressComponent.short_name;
        }
      }

      return {
        location: {
          zipCodes,
          cities,
          state,
          country
        },
        success: true
      };
    }

    return {
      success: false
    };
  });

  return function geocode(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default geocode;